import { useEffect } from 'react';
import { getCookieValue } from 'functions/cookies';
import { COOKIES } from 'consts/cookies';
import { processMarketingParams } from 'functions/marketingParams';

const useProcessMarketingParamsOnPublicPage = () => {
  useEffect(() => {
    if (getCookieValue(COOKIES.logged)) return;
    processMarketingParams();
  }, []);
};

export default useProcessMarketingParamsOnPublicPage;
